import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './subscription.constants';
import * as types from './subscription.types';
import * as services from './subscription.saga-services';

function* invokeInitialSubscriptionPage(_action: types.IInitialSubscriptionPage) {
  yield call(services.initialSubscriptionPage);
}

function* invokeCreateSetupIntent(_action: types.ICreateSetupIntent) {
  yield call(services.createSetupIntent);
}

function* invokeAddPaymentMethod(action: types.IAddPaymentMethod) {
  yield call(services.addPaymentMethod, action.payload);
}

function* invokeSetDefaultPaymentMethod(action: types.ISetDefaultPaymentMethod) {
  yield call(services.setDefaultPaymentMethod, action.payload);
}

function* invokeDeletePaymentMethod(action: types.IDeletePaymentMethod) {
  yield call(services.deletePaymentMethod, action.payload);
}

function* invokeStartBilling(_action: types.IStartBilling) {
  yield call(services.startBilling);
}

function* invokeCancelSubscription(_action: types.ICancelSubscription) {
  yield call(services.cancelSubscription);
}

function* invokeReactivateSubscription(_action: types.IReactivateSubscription) {
  yield call(services.reactivateSubscription);
}

function* invokeSaveBillingInfo(action: types.ISaveBillingInfo) {
  const saved = (yield call(services.saveBillingInfo, action.payload)) as boolean;
  if (action.resolve) {
    action.resolve(saved);
  }
}

export function* watchSubscriptionPageSaga() {
  yield takeLatest(constants.INITIAL_SUBSCRIPTION_PAGE, invokeInitialSubscriptionPage);
  yield takeLatest(constants.CREATE_SETUP_INTENT, invokeCreateSetupIntent);
  yield takeLatest(constants.ADD_PAYMENT_METHOD, invokeAddPaymentMethod);
  yield takeLatest(constants.SET_DEFAULT_PAYMENT_METHOD, invokeSetDefaultPaymentMethod);
  yield takeLatest(constants.DELETE_PAYMENT_METHOD, invokeDeletePaymentMethod);
  yield takeLatest(constants.START_BILLING, invokeStartBilling);
  yield takeLatest(constants.CANCEL_SUBSCRIPTION, invokeCancelSubscription);
  yield takeLatest(constants.REACTIVATE_SUBSCRIPTION, invokeReactivateSubscription);
  yield takeLatest(constants.SAVE_BILLING_INFO, invokeSaveBillingInfo);
}
